import './Venue.css';
import KrakowImage from '../../../assets/images/venue.webp';

export default function Venue() {
    return `
<section class="venue" id="venue">
    <div class="container">
        <div class="venue__header">
            <span class="venue__eyebrow"></span>
            <h2 class="venue__title">
                Venue
            </h2>
        </div>

        <div class="venue__grid">

            <!-- LEWA KOLUMNA: Treść wyrównana do góry zdjęcia -->
            <div class="venue__content">
                
                <p class="venue__lead">
                    The PIEROGY 2027 conference is hosted by the Faculty of Mathematics and Computer Science of the Jagiellonian University in Kraków.
                </p>

                <div class="venue__details">
                    <div class="venue__detail">
                        <span class="venue__label">Conference</span>
                        <span class="venue__value">19–23 April 2027</span>
                    </div>

                    <div class="venue__detail">
                        <span class="venue__label">Address</span>
                        <span class="venue__value">
                            Faculty of Mathematics and Computer Science<br>
                            prof. Stanisława Łojasiewicza 6<br>
                            30-348 Kraków
                        </span>
                    </div>
                </div>

            </div>

            <!-- PRAWA KOLUMNA: Zdjęcie i Karta -->
            <div class="venue__image">
                <img
                    src="${KrakowImage}"
                    alt="Kraków"
                >
                <div class="venue__card">
                    <a
                        href="https://maps.google.com/?q=Faculty+of+Mathematics+and+Computer+Science+Jagiellonian+University+Krakow"
                        target="_blank"
                    >
                        View on Google Maps →
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>
`;
}
